import type { HttpRequest } from '@angular/common/http';

/**
 * Cart routes that change something but are not the rep editing their cart. A failed copy-link or a
 * refused Send Email is reported by its own screen; neither means the rep's work is unsaved, so
 * neither may put "Changes not saved" in the builder's header — nor lose the global loader, since
 * nothing else reports them.
 *
 * Matched as path fragments so they hold whatever the API host is.
 */
const NOT_A_SAVE = [
  // copy-link, resend, void, reactivate, impersonate, invite-user, send-reset-password
  '/carts/quick-actions/',
  '/share',
  '/mark-signed',
];

/**
 * Whether this request is the cart builder saving the rep's work.
 *
 * Everything that writes under `/carts` counts — including `POST /carts`, which is the builder
 * claiming the cart it is about to fill — because the status has to answer for *all* current
 * changes, not just the ones the page itself makes. The step sections each auto-save through their
 * own endpoints, and watching the HTTP layer catches those without every call site opting in.
 *
 * Read by two interceptors: one puts the state in the builder's header, the other keeps these
 * requests out of the global loader.
 */
export function isCartSave(req: HttpRequest<unknown>): boolean {
  if (req.method === 'GET') return false;
  if (!req.url.includes('/carts')) return false;
  return !NOT_A_SAVE.some((fragment) => req.url.includes(fragment));
}
